// extracted by mini-css-extract-plugin
module.exports = {"details_container":"GlobalDetails_details_container__1TCSc"};